import {
  TableProps as MantineTableProps,
  Table as MantineTable,
  TableTheadProps as MantineTableTheadProps,
  TableThead as MantineTableThead,
  TableTbodyProps as MantineTableTbodyProps,
  TableTbody as MantineTableTbody,
  TableTfootProps as MantineTableTfootProps,
  TableTfoot as MantineTableTfoot,
  TableTrProps as MantineTableTrProps,
  TableTr as MantineTableTr,
  TableThProps as MantineTableThProps,
  TableTh as MantineTableTh,
  TableTdProps as MantineTableTdProps,
  TableTd as MantineTableTd,
  TableCaptionProps as MantineTableCaptionProps,
  TableCaption as MantineTableCaption,
  TableScrollContainerProps as MantineTableScrollContainerProps,
  TableScrollContainer as MantineTableScrollContainer,
} from '@mantine/core';

export type TableProps = MantineTableProps;
export type TableTheadProps = MantineTableTheadProps;
export type TableTbodyProps = MantineTableTbodyProps;
export type TableTfootProps = MantineTableTfootProps;
export type TableTrProps = MantineTableTrProps;
export type TableThProps = MantineTableThProps;
export type TableTdProps = MantineTableTdProps;
export type TableCaptionProps = MantineTableCaptionProps;
export type TableScrollContainerProps = MantineTableScrollContainerProps;

export const Table = MantineTable;
Table.displayName = 'Table';

export const TableThead = MantineTableThead;
TableThead.displayName = 'TableThead';

export const TableTbody = MantineTableTbody;
TableTbody.displayName = 'TableTbody';

export const TableTfoot = MantineTableTfoot;
TableTfoot.displayName = 'TableTfoot';

export const TableTr = MantineTableTr;
TableTr.displayName = 'TableTr';

export const TableTh = MantineTableTh;
TableTh.displayName = 'TableTh';

export const TableTd = MantineTableTd;
TableTd.displayName = 'TableTd';

export const TableCaption = MantineTableCaption;
TableCaption.displayName = 'TableCaption';

export const TableScrollContainer = MantineTableScrollContainer;
TableScrollContainer.displayName = 'TableScrollContainer';
